module.exports = __webpack_public_path__ + "img/2009 feuerwehr winteressen 029.645993cb.jpg";